<template>
  <ReportBaseSelectFilter
    class="status-filter"
    label="Statuses"
    placeholder="All statuses"
    :options="options"
    :query-property="queryProperty"
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReportStatusFilter',
  props: {
    queryProperty: {
      type: String,
      default: 'statuses',
    },
  },
  computed: {
    options() {
      if (this.allStatuses) {
        return this.allStatuses.map((status) => {
          return {
            id: status[1],
            text: status[0],
          };
        });
      }

      return [];
    },
    ...mapGetters(['allStatuses']),
  },
};
</script>
